import { Box, Typography } from "@mui/material";

const NotificationToast = ({ title, body, icon }) => {
  return (
    <Box sx={{ display: "flex", gap: "10px", alignItems: "center", p:"5px 0px" }}>
      {/* 🔔 Icon */}
      {icon && (
        <Box
          component="img"
          src={icon}
          alt="notification"
          sx={{
            width: 24,
            height: 24,
            flexShrink: 0,
            marginTop: "2px",
          }}
        />
      )}

      {/* 📄 Content */}
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            color: "#0F172A",
            lineHeight: "20px",
          }}
        >
          {title}
        </Typography>

        {body && (
          <Typography
            sx={{
              fontSize: "13px",
              color: "#64748B",
              lineHeight: "18px",
            }}
          >
            {body}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default NotificationToast;
